import uuid from 'node-uuid';
import { ADD_MESSAGE } from '../redux-action-types';

const addMessage = (text, type) => ({
    message: {
      id: uuid.v1(),
      text,
      type
    },
    type: ADD_MESSAGE
});

export const addSuccessMessage = text => addMessage(text, 'success');
export const addErrorMessage = text => addMessage(text, 'error');



// WEBPACK FOOTER //
// ./src/app/action-creators/add-message.js